"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportAndReturnPolicy = void 0;
const react_1 = __importDefault(require("react"));
const responsive_popover_and_bottomsheet_toggler_1 = require("../responsive-popover-and-bottomsheet-toggler");
const themed_text_1 = require("../themed-text");
const SupportAndReturnPolicy = (props) => {
    return props.primaryMessage ? (react_1.default.createElement(responsive_popover_and_bottomsheet_toggler_1.ResponsivePopoverAndBottomSheetToggler, { primaryContent: react_1.default.createElement(PrimaryContent, { primaryMessage: props.primaryMessage }), innerContent: react_1.default.createElement(InnerPopoverContent, Object.assign({}, props)), headerText: props.title, dataCy: "support-and-return-container" })) : null;
};
exports.SupportAndReturnPolicy = SupportAndReturnPolicy;
const PrimaryContent = ({ primaryMessage }) => {
    return react_1.default.createElement(themed_text_1.ThemedAnchor, { "aria-label": "support and return policy information" }, primaryMessage);
};
const InnerPopoverContent = ({ description, policyLinkDisplayString, policyLinkUrl }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(themed_text_1.ThemedParagraph, null, description),
        react_1.default.createElement(themed_text_1.ThemedAnchor, { href: policyLinkUrl }, policyLinkDisplayString)));
};
